import { defineMessages } from "react-intl";

export const scope = "pages.IntroducingBrokerMembersTable";

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Usuarios",
  },
  searchBy: {
    id: `${scope}.searchBy`,
    defaultMessage: "Buscar por:",
  },
  inputFilterEmail: {
    id: `${scope}.inputFilterEmail`,
    defaultMessage: "Busca por nombre, apellido o mail",
  },
  inputFilterUID: {
    id: `${scope}.inputFilterUID`,
    defaultMessage: "Ingrese UID",
  },
  columnFullName: {
    id: `${scope}.columnFullName`,
    defaultMessage: "NOMBRE Y APELLIDO",
  },
  columnEmail: {
    id: `${scope}.columnEmail`,
    defaultMessage: "Mail",
  },
  columnState: {
    id: `${scope}.columnState`,
    defaultMessage: "ESTADO",
  },
  columnPlatform: {
    id: `${scope}.columnPlatform`,
    defaultMessage: "PLATAFORMA",
  },
  columnLocalMarket: {
    id: `${scope}.columnLocalMarket`,
    defaultMessage: "MERCADO LOCAL",
  },
  columnGlobalMarket: {
    id: `${scope}.columnGlobalMarket`,
    defaultMessage: "MERCADO GLOBAL",
  },
  columnTotal: {
    id: `${scope}.columnTotal`,
    defaultMessage: "TOTAL",
  },
  columnLinks: {
    id: `${scope}.columnLinks`,
    defaultMessage: "ACCIONES",
  },
  linkBalances: {
    id: `${scope}.linkBalances`,
    defaultMessage: "Balances",
  },
  columnNotCreated: {
    id: `${scope}.columnNotCreated`,
    defaultMessage: "Cuenta no creada",
  },
  linkDepositAddresses: {
    id: `${scope}.linkDepositAddresses`,
    defaultMessage: "Direcciones de deposito",
  },
});
